export { default as InputMoneyField } from './InputMoneyField';
